module.exports = __webpack_public_path__ + "880bd3ae8c64f11e5067ac5700726503.jpg";


//////////////////
// WEBPACK FOOTER
// ./apps/www.relic.com/src/img/styles/4_column_xlarge_x1_variable/public/news/img1_1.jpg
// module id = 472
// module chunks = 0